/**
 * Okendo Badge Enhancement
 * Ensures Okendo badges load properly and provides fallback to custom star rating
 */

document.addEventListener('DOMContentLoaded', function() {
  // Wait for Okendo to load
  setTimeout(initializeOkendoBadges, 1000);
  // Also try again after a longer delay in case Okendo loads slowly
  setTimeout(initializeOkendoBadges, 3000);
});

function initializeOkendoBadges() {
  const badges = document.querySelectorAll('[data-oke-custom-badge]');
  if (!badges.length) return;

  const metaEls = document.querySelectorAll(
    'script[type="application/json"][data-oke-metafield-data]'
  );
  if (!metaEls.length) return;

  let meta = null;
  // Pick the most informative Okendo JSON block: prefer one with reviewAggregate.reviewCount > 0,
  // then any with reviewCount > 0, otherwise fall back to the first valid JSON.
  metaEls.forEach((el) => {
    let candidate;
    try {
      candidate = JSON.parse(el.textContent || '{}');
    } catch (e) {
      return;
    }

    if (!meta) {
      meta = candidate;
    }

    if (
      candidate &&
      candidate.reviewAggregate &&
      typeof candidate.reviewAggregate.reviewCount === 'number' &&
      candidate.reviewAggregate.reviewCount > 0
    ) {
      meta = candidate;
    } else if (
      candidate &&
      typeof candidate.reviewCount === 'number' &&
      candidate.reviewCount > 0 &&
      (!meta || !meta.reviewAggregate)
    ) {
      meta = candidate;
    }
  });

  if (!meta) return;

  // Primary summary values
  let averageRating = 0;
  let reviewCount = 0;

  // Prefer aggregate data when available
  if (
    meta.reviewAggregate &&
    typeof meta.reviewAggregate.reviewCount === 'number' &&
    meta.reviewAggregate.reviewCount > 0
  ) {
    reviewCount = meta.reviewAggregate.reviewCount;
    if (
      typeof meta.reviewAggregate.reviewRatingValuesTotal === 'number' &&
      reviewCount > 0
    ) {
      averageRating = meta.reviewAggregate.reviewRatingValuesTotal / reviewCount;
    }
  }

  // Fall back to top-level reviewCount if aggregate not present
  if (!reviewCount && typeof meta.reviewCount === 'number') {
    reviewCount = meta.reviewCount;
  }

  // Fall back to explicit averageRating only if we still don't have one from aggregate
  if (!averageRating && meta.averageRating != null) {
    averageRating = parseFloat(meta.averageRating) || 0;
  }

  badges.forEach(function(badge) {
    renderOkendoBadge(badge, averageRating, reviewCount);

    // Optional debug output into matching <pre>

  });
}

function renderOkendoBadge(badge, averageRating, reviewCount) {
  if (!badge) return;
  if (!averageRating && !reviewCount) {
    badge.innerHTML = '';
    return;
  }

  const showRating = badge.getAttribute('data-show-rating') !== 'false';
  const showCount = badge.getAttribute('data-show-count') !== 'false';

  const container = document.createElement('div');
  container.className = 'okendo-custom-badge';

  const starsWrapper = document.createElement('div');
  starsWrapper.className = 'oke-stars';

  const fullStars = Math.floor(averageRating || 0);
  const decimal = (averageRating || 0) - fullStars;
  const hasHalf = decimal >= 0.5 ? 1 : 0;
  const nextStarIndex = fullStars + 1;

  for (let i = 1; i <= 5; i++) {
    const span = document.createElement('span');
    let classes = 'oke-star ';
    if (i <= fullStars) {
      classes += 'oke-star-full';
    } else if (hasHalf && i === nextStarIndex) {
      classes += 'oke-star-half';
    } else {
      classes += 'oke-star-empty';
    }
    span.className = classes;
    starsWrapper.appendChild(span);
  }

  container.appendChild(starsWrapper);

  if (showRating) {
    const ratingSpan = document.createElement('span');
    ratingSpan.className = 'oke-rating-value';
    ratingSpan.textContent = (averageRating || 0).toFixed(1);
    container.appendChild(ratingSpan);
  }

  if (showCount) {
    const countSpan = document.createElement('span');
    countSpan.className = 'oke-review-count';
    countSpan.textContent = `(${reviewCount || 0} reviews)`;
    container.appendChild(countSpan);
  }

  badge.innerHTML = '';
  badge.appendChild(container);
}

// Re-initialize when page content changes (for AJAX updates)
if (window.MutationObserver) {
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length > 0) {
        setTimeout(initializeOkendoBadges, 500);
      }
    });
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}
